export default function PricingIntervalToggle({ interval, onChange }) {
  const isMonthly = interval === "month";
  const isAnnual = interval === "year";
  const baseBtn = "px-4 py-1.5 rounded-full text-sm transition-colors";
  const activeBtn = "bg-white text-stone-900 shadow-sm";
  const idleBtn = "text-stone-500 hover:text-stone-800";

  return (
    <div
      className="mt-6 inline-flex items-center gap-1 p-1 rounded-full bg-muted border border-border"
      data-testid="billing-interval-toggle"
    >
      <button
        onClick={() => onChange("month")}
        className={`${baseBtn} ${isMonthly ? activeBtn : idleBtn}`}
        data-testid="interval-monthly-btn"
      >
        Monthly
      </button>
      <button
        onClick={() => onChange("year")}
        className={`${baseBtn} flex items-center gap-1.5 ${isAnnual ? activeBtn : idleBtn}`}
        data-testid="interval-annual-btn"
      >
        Annual
        <span className="text-[10px] uppercase tracking-widest bg-primary/10 text-primary px-1.5 py-0.5 rounded-full">
          Save 2 mo
        </span>
      </button>
    </div>
  );
}
